<script setup lang="ts">
const props = defineProps<{
  glow?: boolean
  on: boolean

  width?: '_wmax' | '_w100p'
  border?: 'list' | '_br14' | '_br9' | 'pill' | undefined
  align?: '_align-start' | '_ctrY'
  fw?: '_fw-l' | '_fw-xl'

  ui?: 'none'
  disabled?: boolean | undefined
  click: () => void
  txt?: string | undefined

  iconTxt?: stringI18n | undefined
  right?: boolean
  openUpdate?: boolean | 'remove'

  txtRow?: boolean
}>()

const css = useCssModule()
const classes = computed(() => {
  const { align = '_ctrY', width = '_w100p', border, on, glow, right, iconTxt, fw = '_fw-l' } = props
  return [
    css.m,
    fw,
    border === 'list' ? '_b5 _bw10 _mt-1 _mb-1' : border === 'pill' ? '_br99 _b5' : border,
    border === 'pill' ? '_pr14' : 'd_hm54 m_hm64 _pr04',
    border === 'list' ? '_gap2' : '_gap1',
    glow && css.glow,
    right ? '_pl14 _spaced' : '_pl08',
    iconTxt ? 'ButtonIcon' : 'IconCheckbox',
    width,
    align,
    on && 'on',
  ]
})
</script>

<template>
  <button type="button" :class="classes" :disabled @click.passive="() => click()" @keypress.passive.enter="() => click()">
    <ButtonOptionSwich :right>
      <template #left>
        <ButtonIcon v-if="openUpdate" :txt="iconTxt" size="36" to="span" :right="!right" :disabled>
          <IconChevron v-if="openUpdate === true" :open="!!on" size="_svg16" />
        </ButtonIcon>
        <ButtonIcon v-else-if="iconTxt" size="18" :txt="iconTxt" :class="$style.close" to="span" :open="on" :right="!right" :disabled />
        <IconCheckbox v-else round :disabled />
      </template>

      <span class="_wmin0 _flex" :class="[txtRow ? '_row _gap1 _ctrY' : '_txt_inline']"
        ><slot>{{ txt }}</slot></span
      >
    </ButtonOptionSwich>
  </button>
</template>

<style module>
.m {
  composes: global(_relative);
  composes: global(_hidden);

  composes: global(_row);

  composes: global(_fs09);
  composes: global(_ls-xs);
  composes: global(_lh12);

  composes: global(_c1);

  composes: global(_pt08);
  composes: global(_pb08);

  composes: global(_bg0);
  outline: none;
  z-index: 0;
  cursor: pointer;
}

.m:disabled {
  cursor: not-allowed;
  background: var(--black-6);
  color: var(--black-4);
  border-color: var(--black-5);
}

.close {
  composes: global(_bg0);
  --w: 20px;
}

:global(.d) .m:not(:disabled):not(:global(.on)):hover {
  background: var(--black-5);
  z-index: 1;
}

.glow {
  box-shadow: 0 0 0 2px var(--blue7);
  border-color: transparent;
  z-index: 1;
}
</style>
